<template>
    <template v-if="promos">
        <div class="sb-inner" v-if="promos.length > 0">
            <div class="sb-card" v-for="(promo) in promos" :key="promo">
                <router-link :to="'/promo/detail/' + promo.slug">
                    <div class="sbc-content">
                        <div class="sbc-image">
                            <img :src="promo.thumbnail_url" alt="melinda hospital" v-if="promo.thumbnail_url" />
                            <img src="../../assets/images/pictures/emptypp.webp" alt="melinda hospital" v-else/>
                        </div>
                        <div class="sbc-detail">
                            <div class="sd-specialist">
                                <span>{{ promo.facility_name }}</span>
                            </div>
                            <h3>{{ toTitleCase(wordsLimit(promo.name, 50)) }}</h3>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="search-not-found" v-else>
            <p v-if="searchbarCategory.input.value || searchbarSelectCategory.input.value.length">Tidak ditemukan promo dengan kata kunci</p>
            <p v-else>Tidak ada promo</p>
            <div v-if="searchbarCategory.input.value">"{{ searchbarCategory.input.value }}"</div>
            <div v-if="searchbarSelectCategory.input.value.length > 0">"{{ searchbarSelectCategory.input.value }}"</div>
        </div>
        <div class="page-more">
            <div class="next-loading" v-if="nextLoading">
                <div class="loader-next"></div>
            </div>
            <div class="page-next" v-if="metaPage?.to < metaPage?.total">
                <span @click="nextPage">Selanjutnya...</span>
            </div>
        </div>
    </template>
</template>
<script setup>
    import { computed } from "@vue/runtime-core";
    import { usePromoStore } from "../../stores/promo";
    import { nextPage } from "@/functions/promo";
    import { toTitleCase, wordsLimit } from "@/functions/general";
    const promos = computed(() => usePromoStore().filteredPromos);
    const searchbarCategory = computed(() => usePromoStore().searchbarCategory);
    const searchbarSelectCategory = computed(() => usePromoStore().searchbarSelectCategory);
    const metaPage = computed(() => usePromoStore().metaPage);
    const nextLoading = computed(() => usePromoStore().nextLoading);
</script>
<style scoped src="../../assets/css/promos/promo-list.css">
    @import url('../../assets/css/loaders/loader-next.css');
    /* @import url('../../assets/css/promos/promo-list.css'); */
</style>